import duckLogo from './assets/logo-duck-fractions.svg';
import washOperationsLogo from './assets/logo-wash-operations.svg';
import homeLogo from './assets/logo-home.png';
import contactLogo from './assets/logo-contact.png';

export type LoaderSkinData = {
  logo: string;
  backgroundColor: string;
  progressBarColor?: string;
};

export type LoaderType = 'multiplication' | 'fractions' | 'operations' | 'home' | 'contact';

export const getLoaderSkin = (loaderType: LoaderType): LoaderSkinData => {
  switch (loaderType) {
    case 'home':
      return {
        logo: homeLogo,
        backgroundColor: '#c0c7c8',
        progressBarColor: '#000',
      };
    case 'fractions':
      return {
        logo: duckLogo,
        backgroundColor: '#3A1241',
      };

    case 'operations':
      return {
        logo: washOperationsLogo,
        backgroundColor: '#23FFD2',
      };
      case 'contact':
      return {
        logo: contactLogo,
        backgroundColor: '#f78cae',
        // progressBarColor: '#ffc600',
      };

    default:
      throw new Error('Unknown loader type');
  }
};
